.app {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

.app main {
  flex: 1;
}
